export type ExperienceFilterValues = {
  locationIds: string[];
  languages: string[];
  tagIds: string[];
};

// Minimal shape needed to filter — the LoaderExperience superset satisfies it.
export type FilterableExperience = {
  id: string;
  locationIds: string[];
  languageCodes: string[];
  tagIds: string[];
};

export function filterExperiences<T extends FilterableExperience>(
  experiences: T[],
  filters: ExperienceFilterValues
): T[] {
  return experiences.filter((exp) => {
    if (filters.tagIds.length > 0) {
      if (!exp.tagIds.some((t) => filters.tagIds.includes(t))) return false;
    }
    if (filters.locationIds.length > 0) {
      if (!exp.locationIds.some((l) => filters.locationIds.includes(l)))
        return false;
    }
    if (filters.languages.length > 0) {
      if (!exp.languageCodes.some((lang) => filters.languages.includes(lang)))
        return false;
    }
    return true;
  });
}
